<div class="expense-dialog">
  <form name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
    <header class="dialog-header">
      <div>
        <h2>Utlägg</h2>
        <p>Lägg till utlägg och underlag för din utbetalning.</p>
      </div>
      <button type="button" mat-icon-button aria-label="Stäng dialogrutan" matTooltip="Stäng" (click)="cancel()">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <div class="expense-content">
    <section class="form-section form-section--billing" *ngIf="!deduction?.GroupId || data?.showInvoiceBillingChoice">
      <div class="billing-toggle">
        <h3>Fakturera kund</h3>
        <mat-checkbox [(ngModel)]="deduction.AddedToInvoice"
                      (ngModelChange)="onAddedToInvoiceChange($event)"
                      name="addedToInvoice"
                      [disabled]="data?.status?.TechnicalName !== 'Draft' || !isInvoiceCurrencySek"
                      aria-label="Kunden ska faktureras för detta utlägg">
          Kunden ska faktureras för detta utlägg
        </mat-checkbox>
      </div>
      <p class="billing-locked-message" *ngIf="data?.status?.TechnicalName !== 'Draft'">Detta val kan bara väljas om fakturan inte skickats ännu.</p>

    </section>

    <section class="form-section">
      <div class="section-heading">
        <h3>Uppgifter om utlägget</h3>
        <p>Beskriv vad kostnaden avser och ange beloppet på kvittot.</p>
      </div>

      <mat-form-field class="form-field" floatLabel="always" *ngIf="deduction.AddedToInvoice">
        <mat-label>Text på kundfakturan</mat-label>
        <input type="text" matInput [ngModel]="deduction.Name" (ngModelChange)="deduction.Name = $event" required maxlength="50" id="name" name="name" />
      </mat-form-field>

      <mat-form-field class="form-field form-field--description" floatLabel="always">
        <mat-label>Beskrivning/syfte</mat-label>
        <textarea matInput [ngModel]="deduction.Description" (ngModelChange)="deduction.Description = $event" required maxlength="500" rows="4" id="message" name="message"></textarea>
      </mat-form-field>

      <mat-form-field class="form-field" floatLabel="always" subscriptSizing="dynamic">
        <mat-label>Belopp enligt kvitto (SEK)</mat-label>
        <input type="number" step="0.01" matInput [ngModel]="deduction.Amount" (ngModelChange)="onReceiptAmountChange($event)" required id="amount" name="amount" />
        <mat-hint>Beloppet betalas ut som skattefritt utlägg.</mat-hint>
      </mat-form-field>

      <div class="billing-fields" *ngIf="deduction.AddedToInvoice">
        <mat-form-field class="form-field" floatLabel="always" subscriptSizing="dynamic">
          <mat-label>Belopp att fakturera (SEK)</mat-label>
          <input type="number" step="0.01" matInput [ngModel]="deduction.AgreedInvoiceAmount" (ngModelChange)="onAgreedInvoiceAmountChange($event)" id="agreedInvoiceAmount" name="agreedInvoiceAmount" />
          <mat-hint>Detta belopp visas på och faktureras till kunden.</mat-hint>
        </mat-form-field>
      </div>
    </section>

    <section class="form-section">
      <div class="section-heading">
        <h3>Typ av utlägg</h3>
      </div>

      <div class="choice-card">
        <div>
          <h4>Reseutlägg</h4>
          <p>Till exempel tåg, hotell, taxi eller annan resa i samband med uppdraget.</p>
        </div>
        <mat-checkbox [ngModel]="TravelExpense" [checked]="TravelExpense" (change)="changeValue($event, 'travel')" name="TravelExpense" aria-label="Är reseutlägg">Ja</mat-checkbox>
      </div>

      <div class="choice-card">
        <div>
          <h4>Friskvårdsavdrag</h4>
          <p>Gäller kvittot en friskvårdsaktivitet?</p>
        </div>
        <mat-checkbox [ngModel]="HealthCare" [checked]="HealthCare" (change)="changeValue($event, 'health')" name="HealthCare" aria-label="Är friskvårdsavdrag">Ja</mat-checkbox>
      </div>

      <p class="health-care-info" *ngIf="HealthCare">Du har {{5000 - HealthCareAmountThisYear}} SEK kvar att utnyttja av årets friskvårdsavdrag.</p>
    </section>

    <section class="form-section">
      <div class="section-heading">
        <h3>Underlag</h3>
        <p>Ladda upp kvitto, faktura eller annat dokument som styrker utlägget.</p>
      </div>

      <div class="upload-field">
        <div class="upload-field-header">
          <label for="deduction-attachment">Underlag <span aria-hidden="true">*</span></label>
          <span *ngIf="deduction.Attachment?.Guid">Uppladdat</span>
        </div>
        <div *ngIf="deduction.Attachment.Guid == null" class="file-picker">
          <label class="file-picker-button" for="deduction-attachment">Välj fil</label>
          <span>{{deduction.Attachment.Name || 'Ingen fil har valts'}}</span>
          <input id="deduction-attachment" type="file" (change)="fileChange($event,deduction.Attachment)" accept=".pdf,.jpeg,.jpg,.png,.gif">
        </div>
        <div class="file-actions" *ngIf="deduction.Attachment.Guid != null">
          <button type="button" mat-stroked-button (click)="showFile(deduction.Attachment)"><mat-icon>open_in_new</mat-icon> Visa dokument</button>
          <button type="button" mat-stroked-button class="button--danger" (click)="deleteFile(deduction.Attachment)">Radera</button>
        </div>
        <p class="error-message" *ngIf="fileSizeErrorAttachment">{{fileSizeErrorAttachment}}</p>
      </div>

      <div class="upload-field">
        <div class="upload-field-header">
          <label for="deduction-receipt">Betalningskvitto</label>
          <span>Valfritt</span>
        </div>
        <p class="field-help">Om underlaget ovan är en faktura måste du ladda upp en kvittens på att fakturan är betald.</p>
        <div *ngIf="deduction.AttachmentReciept.Guid == null" class="file-picker">
          <label class="file-picker-button" for="deduction-receipt">Välj fil</label>
          <span>{{deduction.AttachmentReciept.Name || 'Ingen fil har valts'}}</span>
          <input id="deduction-receipt" type="file" (change)="fileChange($event,deduction.AttachmentReciept)" accept=".pdf,.jpeg,.jpg,.png,.gif">
        </div>
        <div class="file-actions" *ngIf="deduction.AttachmentReciept.Guid != null">
          <button type="button" mat-stroked-button (click)="showFile(deduction.AttachmentReciept)"><mat-icon>open_in_new</mat-icon> Visa dokument</button>
          <button type="button" mat-stroked-button class="button--danger" (click)="deleteFile(deduction.AttachmentReciept)">Radera</button>
        </div>
        <p class="error-message" *ngIf="fileSizeErrorReceipt">{{fileSizeErrorReceipt}}</p>
      </div>
    </section>

    <footer class="dialog-actions">
      <p *ngIf="getMissingRequirementMessage(f) as missingMessage">{{missingMessage}}</p>
      <div>
        <button type="button" mat-stroked-button (click)="cancel()">Avbryt</button>
        <button mat-flat-button color="primary" [disabled]="!f.form.valid || deduction.Attachment.Guid == null">Spara utlägg</button>
      </div>
    </footer>
    </div>
  </form>
</div>
